<template>
  <div class="app-container">
    <div class="base-info">
      <div>
        淤地坝名称: <span>{{ currentRecord.ydbName }}</span>
      </div>
      <div>
        行政区划: <span>{{ currentRecord.address }}</span>
      </div>
      <div>
        巡检人: <span>{{ currentRecord.patrolUser }}</span>
      </div>
      <div>
        巡检时间: <span>{{ currentRecord.patrolTime }}</span>
      </div>
    </div>

    <el-table :height="'65vh'" v-loading="loading" :data="patrolIssueRecordList">
      <el-table-column label="序号" align="center" prop="id" />
      <el-table-column label="问题" align="center" prop="issue">
        <template slot-scope="scope">
          <span v-for="dict in patrol_issue" :key="dict.value">
            <span v-if="dict.value == scope.row.issue">{{dict.label}}</span>
          </span>
        </template>
      </el-table-column>
      <el-table-column label="问题附件" align="center" prop="issueUrl">
        <template slot-scope="scope">
          <media-slot :issueUrlStr="scope.row.issueUrl"></media-slot>
        </template>
      </el-table-column>
      <el-table-column label="核实意见" align="center" prop="opinion" />
      <el-table-column label="核实附件" align="center" prop="opinionUrl">
        <template slot-scope="scope" v-if="scope.row.opinionUrl">
          <div
            v-for="(url, index) in scope.row.opinionUrl.split(',')"
            :key="index"
          >
            <el-link
              v-show="url.split('/') && url.split('/').length > 0"
              :href="url"
              :underline="false"
              target="_blank"
              >{{ url.split("/").reverse()[0] }}</el-link
            >
          </div>
        </template>
      </el-table-column>
      <el-table-column label="状态" align="center" prop="status">
        <template slot-scope="scope">
          <span v-for="dict in issue_status" :key="dict.value">
            <el-button v-if="dict.value == scope.row.status" :type="dict.type" plain>{{dict.label}}</el-button>
          </span>
        </template>
      </el-table-column>
      <el-table-column label="问题类型" align="center" prop="issueType">
        <template slot-scope="scope">
          <span v-for="dict in issue_type" :key="dict.value">
            <span v-if="dict.value == scope.row.issueType">{{dict.label}}</span>
          </span>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        class-name="small-padding fixed-width"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.status == '1'">
            <el-button
              size="small"
              type="primary"
              @click="handleDestory(scope.row)"
              >销毁</el-button
            >
            <el-button
              size="small"
              type="primary"
              @click="handleCheck(scope.row)"
      
              >核实</el-button
            >
          </div>
          <span v-else>-</span>
        </template>
      </el-table-column>
    </el-table>

    <!-- 添加或修改巡检问题对话框 -->
    <el-dialog :title="title" :visible.sync="open" width="600px" append-to-body>
      <el-form ref="form" :model="form" :rules="rules" label-width="130px">
        <el-form-item label="核实意见" prop="opinion">
          <textarea
            id="checkSuggest"
            cols="40"
            rows="10"
            v-model="form.opinion"
          ></textarea>
        </el-form-item>
        <el-form-item label="附件上传" prop="issueUrl">
          <file-upload
            :uploadFileUrl="uploadFileUrl"
            :fileType="['doc', 'xls', 'ppt', 'txt', 'pdf', 'png', 'jpg']"
            :fileSize="100"
            v-model="form.opinionUrl"
          ></file-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm('2')">重复</el-button>
        <el-button type="success" @click="submitForm('1')">新增</el-button>
        <el-button @click="cancel">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Axios from 'axios';
import MediaSlot from "@/components/mediaSlot/index.vue";
import FileUpload from "@/components/FileUpload/index.vue"

export default {
  name: "IssueRecord",
  props: ["currentRecord"],
  components: { MediaSlot, FileUpload },
  data() {
    return {
      // 遮罩层
      loading: true,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      // 巡检问题表格数据
      patrolIssueRecordList: [],
      // 弹出层标题
      title: "",
      // 是否显示弹出层
      open: false,
      // 查询参数
      queryParams: {
        issue: null,
        issueUrl: null,
        status: null,
      },
      // 表单参数
      form: {
      },
      // 表单校验
      rules: {},
      uploadFileUrl:"/hzyApi/hwDocking/uploadFile",
      issue_status: [
        {
          value: 1,
          label: "待确认",
          type: 'primary'
        },
        {
          value: 2,
          label: "已销毁",
          type: 'info'
        },
        {
          value: 3,
          label: "正在解决",
          type: 'danger'
        },
        {
          value: 4,
          label: "已解决",
          type: 'success'
        }
      ],
      issue_type: [
        {
          value: 1,
          label: "新增问题",
        },
        {
          value: 2,
          label: "重复问题",
        },
      ],
      patrol_issue: [
        {
          value: 1,
          label: "卧管、竖井",
        },
        {
          value: 2,
          label: "涵洞",
        },
        {
          value: 3,
          label: "溢洪道",
        },
        {
          value: 4,
          label: "坝体",
        },
        {
          value: 5,
          label: "上坝道路",
        },
      ],
      headers: { 
        "Access-Token": this.$store.state.token
      }
    };
  },
  created() {
    this.getList();
    this.form.username = this.$store.state.name;
  },
  methods: {
    getImageList(row) {
      if (!row || !row.issueUrl || row.issueUrl.length == 0) {
        return [];
      }
      let issueUrls = [];
      row.issueUrl.split(",").forEach((ele) => {
        if (ele && ele.length > 0) {
          issueUrls.push(ele);
        }
      });
      return issueUrls;
    },
    /** 查询巡检问题列表 */
    getList() {
      this.patrolIssueRecordList = [];
      this.loading = true;
      Axios.get("/hzyApi/hwDocking/getIssueListByPatrolId", {
        params: {
          patrolId: this.currentRecord.id
        },
        headers: this.headers
      }).then(res => {
        // console.log("res----getIssueListByPatrolId-------", res)
        if(res.data.code == 200) {
          this.patrolIssueRecordList = res.data.data;
        } 
        this.loading = false;
      })
    },
    // 表单重置
    reset() {
      this.form = {
        id: null,
        patrolId: null,
        issue: null,
        issueUrl: null,
        status: null,
        opinion: null,
        username: null
      };
      this.resetForm("form");
    },
    /** 销毁按钮操作 */
    handleDestory(row) {
      // console.log("row---handleDestory--", row);
      this.$confirm("确定销毁？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // 走api
          this.form.patrolId = row.patrolId;
          this.form.id = row.id;
          this.form.issue = row.issue;
          this.form.status = "2";
          this.updateStatus();
        })
        .catch(() => {});
    },
    /** 修改状态与服务器通讯 */
    updateStatus() {
      Axios.post("/hzyApi/hwDocking/issueOperate",this.form,{
        params: this.form,
        headers: this.headers
      }).then(res => {
        // console.log("res====", res)
        if(res.data.code == 200) {
          this.$modal.msgSuccess("修改成功");
          this.getList();
        }
      })
    },
    /** 核实按钮操作 */
    handleCheck(row) {
      // console.log("row---handleCheck--", row);
      this.open = true;
      this.title = "核实";
      this.form.id = row.id;
      this.form.patrolId = row.patrolId;
      this.form.issue = row.issue;
    },
    /** 弹窗确定按钮 */
    submitForm(issueType) {
      this.form.issueType = issueType;
      this.form.status = "3";
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.updateStatus();
          this.open = false;
          this.reset();
        }
      });
    },
    /** 取消按钮 */
    cancel() {
      this.open = false;
      this.reset();
    },
  },
};
</script>

<style scoped>
.base-info {
  width: 100%;
  display: flex;
  font-size: 18px;
  margin-bottom: 2vh;
}
.base-info > div {
  margin-right: 2vw;
}
.base-info > div > span {
  font-weight: bold;
}
</style>
